import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { useState } from "react";
import { Box, Button, Tab, Tabs } from "@mui/material";
import SearchBar from "../../components/SearchBar";
import DownloadIcon from "@mui/icons-material/Download";
import React from "react";
import FilterMenu from "../../components/filterMenu";

function CustomTabPanel(props: {
  children?: React.ReactNode;
  index: number;
  value: number;
}) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageTransactions = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [valueTabs, setValueTabs] = useState(0);

  const userTransactions = [
    {
      id: "SUB001",
      userName: "John Doe",
      email: "john@example.com",
      membership: "Single",
      amount: "200 AED",
      date: "2025-07-01",
      status: "Success",
    },
    {
      id: "SUB002",
      userName: "Jane Smith",
      email: "jane@example.com",
      membership: "Duo",
      amount: "350 AED",
      date: "2025-07-03",
      status: "Pending",
    },
  ];

  const offerTransactions = [
    {
      id: "REQ001",
      offerName: "Romantic Dinner",
      startDate: "2025-07-05",
      endDate: "2025-07-05",
      category: "Dining",
      bookingid: "#101",

      date: "2025-07-03",

      amount: "500 AED",
    },
    {
      id: "REQ002",
      offerName: "Corporate Retreat",
      startDate: "2025-07-10",
      endDate: "2025-07-12",
      category: "Event",
      bookingid: "#102",

      date: "2025-07-03",

      amount: "1500 AED",
    },
  ];

  const cancellationTransactions = [
    {
      id: "CXN001",
      offerName: "Luxury Spa Day",
      category: "Experience",
      amount: "300 AED",
      employeeName: "Emma Watson",
      date: "2025-07-03",
      bookingid: "#101",

      clientName: "Clark Kent",
      status: "Refunded",
    },
    {
      id: "CXN002",
      offerName: "Sunset Cruise",
      category: "Experience",
      amount: "600 AED",
      employeeName: "Bruce Wayne",
      date: "2025-07-03",
      bookingid: "#102",
      clientName: "Diana Prince",
      status: "Pending",
    },
  ];

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Transactions</h1>
       
      </div>

      <Box className="custom_tabs2 mt_40 mb_30" sx={{ width: "100%" }}>
        <Tabs
          value={valueTabs}
          onChange={(e, val) => setValueTabs(val)}
          className="custom_tabs_links"
        >
          <Tab label="Subscriptions" {...a11yProps(0)} />
          <Tab label="Bookings" {...a11yProps(1)} />
          <Tab label="Cancelled Bookings" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <div className="stats_boxes gap_m">
        <div className="cards">
          <h2>Total Amount</h2>
          <h3>$2000</h3>
        </div>
      </div>
      <div className="cards mt_20">
        <div className="table_header">
          <div className="left_s">
            <Box className="search_box">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search..."
              />
            </Box>
          </div>
          <div className="right_s">
            <FilterMenu />
            <Button className="btn btn_grey">
              <DownloadIcon /> Export
            </Button>
          </div>
        </div>

        {/* User Transactions Table */}
        <CustomTabPanel value={valueTabs} index={0}>
          <div className="table_container">
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th>Transaction ID</th>
                  <th>User Name</th>
                  <th>Email</th>
                  <th>Membership Type</th>
                  <th>Amount</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {userTransactions.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td
                      className="cursor_p"
                      onClick={() => navigate("/manage-customers/detail")}
                    >
                      {item.userName}
                    </td>
                    <td>{item.email}</td>
                    <td>{item.membership}</td>
                    <td>{item.amount}</td>
                    <td>{item.date}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CustomTabPanel>

        {/* Offers Table */}
        <CustomTabPanel value={valueTabs} index={1}>
          <div className="table_container">
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th>Transaction ID</th>
                  <th>Booking ID</th>
                  <th>Offer Name</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Category</th>
                  <th>Transaction Date</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {offerTransactions.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td
                      className="cursor_p"
                      onClick={() =>
                        navigate("/manage-booking-resvp/booking-detail")
                      }
                    >
                      {item.bookingid}
                    </td>

                    <td>{item.offerName}</td>
                    <td>{item.startDate}</td>
                    <td>{item.endDate}</td>
                    <td>{item.category}</td>
                    <td>{item.date}</td>

                    <td>{item.amount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CustomTabPanel>

        {/* Cancellations Table */}
        <CustomTabPanel value={valueTabs} index={2}>
          <div className="table_container">
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th>Transaction ID</th>
                  <th>Booking ID</th>
                  <th>Offer Name</th>
                  <th>Category</th>
                  <th>Amount</th>
                  <th>Employee Name</th>
                  <th>Client Name</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {cancellationTransactions.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td
                      className="cursor_p"
                      onClick={() =>
                        navigate("/manage-booking-resvp/booking-detail")
                      }
                    >
                      {item.bookingid}
                    </td>
                    <td>{item.offerName}</td>
                    <td>{item.category}</td>
                    <td>{item.amount}</td>
                    <td>{item.employeeName}</td>
                    <td>{item.clientName}</td>
                    <td>{item.date}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CustomTabPanel>
      </div>
    </MainContainer>
  );
};

export default ManageTransactions;
